<style>
  html {
    scroll-behavior: smooth;
  }
  .backgroundimg{
    position:absolute;top:0;left:-20px;opacity:0.5
  }
  .backgroundimgmobile{
    position:absolute;top:0;left:-20px;opacity:0.1
  }
  .body {
    overflow-y:scrool;
    position:absolute;
    top:0;bottom:0;right:0;left:0
  }

  .videoitem {
    position: absolute;
    right: 0;
    bottom: 0;
    top:0rem;
    min-width: 100%;
    min-height: 100%;
    filter: brightness(40%);
  }

  .content {
    position:absolute;
    left:15%;
    top:0;
    bottom:0;
    right:15%;
    overflow-y:scroll;
    margin-left:1rem;
    margin-top:2rem
  }

  .splash-screen-item {
    border-style: solid !important;
    border-width: 0.1rem !important;
    border-color: white !important;
  }

  /* #### Mobile Phones Portrait or Landscape #### */
  @media screen and (max-device-width: 640px){
    .content-mobile {
      left:0;
      right:0;
    }
  }


</style>
<template >
  <div class="body">
      <!-- The video -->
      <div style="background-color:black;height:100%;width:100%;opacity:0.5">ciao</div>
      <video autoplay muted loop class="videoitem">
        <source src="/assets/asset-tracking-home.mp4" type="video/mp4">  
      </video>

      <v-layout xs12 row wrap class="content content-mobile" style="z-index:1"
        >
        <v-flex xs12 style="margin-bottom:3rem">
          <h1 style="color:#FAFAFA">ASSET-TRACKING PLATFORM</h1>
          <h2 style="color:#BDBDBD;">Dashboard and Device Management</h2>

        </v-flex> 
        <v-flex xs12>
          <v-layout xs12 row wrap id="section1" style="margin-bottom:5rem">

            <!-- Device registration -->
            <v-flex xs12 sm6 style="padding:1rem">
              <v-card color="#002052" class="white--text splash-screen-item" style="height:100%">
                <v-layout align-center>
                  <v-flex xs5  class="green lighten-4">
                    <v-icon large class="green--text" style="">memory</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">1. Register and configure your devices</div>
                        <div>Follow this <a  v-on:click="browse( {name : 'howto'})">guide</a> to register a new device based on its connectivity capability.</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn color="green " dark v-on:click="browse( {name : 'devices'})" >Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            
            <!-- Device telemetry -->
             <v-flex xs12 sm6 style="padding:1rem" >
              <v-card color="#002052" class="white--text splash-screen-item" style="height:100%" >
                <v-layout align-center>
                  <v-flex xs5 class="orange lighten-4">
                    <v-icon large class="orange--text" style="">bar_chart</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">2.  Look at your devices telemetry</div>
                        <div>Select one or more device and the window time interested in, and then visualize telemetry data received by devices.</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn  color="orange " dark  v-on:click="browse( {name : 'telemetry'})">Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <!-- Device events -->
             <v-flex xs12 sm6 style="padding:1rem">
              <v-card color="#002052" class="white--text splash-screen-item"  style="height:100%">
                <v-layout align-center>
                  <v-flex xs5 class="red lighten-4">
                    <v-icon large class="red--text" style="">flash_on</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">3. Analyze the events detected by your devices</div>
                        <div>Select one or more device and the window time interested in, and then visualize events received by devices.</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn  color="red " dark   v-on:click="browse( {name : 'telemetry'})">Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <!-- Device map -->
             <v-flex xs12 sm6 style="padding:1rem">
              <v-card color="#002052" class="white--text splash-screen-item" style="height:100%">
                <v-layout align-center>
                  <v-flex xs5 class="cyan lighten-4">
                    <v-icon large class="cyan--text" style="">map</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">4. Monitor your device on their geo localization</div>
                        <div>Select one or more device and the window time interested in, and then visualize geo-position data received by devices.</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn  color="cyan " dark   v-on:click="browse( {name : 'map'})">Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <!-- Device geofencing -->
             <v-flex xs12 sm6 style="padding:1rem">
              <v-card color="#002052" class="white--text splash-screen-item" style="height:100%">
                <v-layout align-center>
                  <v-flex xs5 class="purple lighten-4">
                    <v-icon large class="purple--text" style="">local_pizza</v-icon>
                  </v-flex>
                  <v-flex xs7>
                    <v-card-title primary-title style="text-align:left">
                      <div>
                        <div class="title" style="margin-bottom:0.5rem">5. Set and detect geofencing events</div>
                        <div>Select one or more device and draw an area on map in order to enable tracking of geofence events raised by devices.</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn  color="purple " dark   v-on:click="browse( {name : 'map'})">Go</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>


          </v-layout>
        </v-flex>
      </v-layout>
      
    <!-- <v-carousel hide-delimiters>
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
      >
        <h1>Ciao</h1>
      </v-carousel-item>
    </v-carousel> -->
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'Home',
  props:["backimage"],
  data () {
      return {
          alert:true,
          model: 0,
          showArrows: true,
          hideDelimiters: false,
          cycle: false,
          homevideo: window.homevideo,
          items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
      },
  computed:{
      ...mapState({
          content: state => state
                              .metadata
                              .models
                              .views
                              .homepage
                              .content
      })
  },

  methods:{
    async browse(view){
      //this.$router.push(view)
      await this.$store.commit('browseApp',view) 
    }
  }
}
</script>